export default __webpack_public_path__ + "static/media/receipt-tear.b7de0f2e.png";